import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { EventsCarouselComponent } from '../events-carousel/events-carousel.component';
import { DataService } from '../../services/data.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-widget-close-events-carousel',
  templateUrl: './widget-close-events-carousel.component.html',
  styleUrls: ['./widget-close-events-carousel.component.scss']
})
export class WidgetCloseEventsCarouselComponent extends EventsCarouselComponent implements OnInit {
  @Input({ required: true }) widgetData!: any;
  @Output() widgetLoaded: EventEmitter<void> = new EventEmitter<void>();
  isLoading: boolean = false;
  isServerError: boolean = false;

  @ViewChild('carousel') carousel: any;
  lockNext: boolean = false;
  lockPrev: boolean = true;

  constructor(private dataService: DataService, private cdr: ChangeDetectorRef) {
    super();
  }

  ngOnInit(): void {
    this.getEvents();
  }

  getEvents() {
    this.isLoading = true;
    let url = environment.apiUrl + '/Portal/Api/Widgets/GetEventsForWidget';
    let request: any = {
      cultureCode: this.dataService.getCultureCode(),
      maxDisplayItems: this.widgetData.maxDisplayItems
    };
    this.dataService.getDataByToken(url, request).subscribe({
      next: (responseData) => {
        this.events = responseData;
        this.isLoading = false;
        this.widgetLoaded.emit();

        setTimeout(() => {
          this.carousel?.nativeElement.swiper.on('slideChange', () => {
            setTimeout(() => {
              this.checkLockNavigation();
            }, 50);
          });
        }, 200);

      },
      error: (e: any) => {
        console.error(e);
        this.isLoading = false;
        this.isServerError = true;
      }
    });
  }

  prevSlide() {
    this.carousel.nativeElement.swiper.slidePrev(500);
  }

  nextSlide() {
    this.carousel.nativeElement.swiper.slideNext(500);
  }

  checkLockNavigation() {
    this.lockNext = this.carousel.nativeElement.swiper.isEnd;
    this.lockPrev = this.carousel.nativeElement.swiper.isBeginning;
    this.cdr.detectChanges();
  }
}
